export default __webpack_public_path__ + "static/brochure1-87564fe9d321e780ba2aea45ba490199.webp";